import { Environment } from 'Environment';

const currentUser = require('system/currentUser');
const Radar = require('system/libs/Radar');
const xTabId = require('xTabId');
const xPageId = require('xPageId');

// Название проекта для http://mail.statd3.mail.ru/?module=common-radar&alias=<project>
let project;

if (Environment.isAutoTesting) {
    project = 'mcsauto';
} else if (Environment.isProductionRun) {
    project = 'mcs';
} else if (Environment.isStagingRun) {
    project = 'mcsstage';
} else if (Environment.isTestingRun) {
    project = 'mcstest';
} else {
    project = 'mcsdev';
}

class RadarDisabler extends Radar {
    send() {
        return Promise.resolve();
    }
}

export default function radar(group) {
    if (Environment.isPrivateBuild) {
        return new RadarDisabler();
    }

    return new Radar(project, group)
        .param('x-tab-id', xTabId)
        .param('x-page-id', xPageId)
        .param('email', currentUser.get('email'))
        .param('rnd', Math.round(Math.random() * 10e16).toString(36));
    // TODO build version
}
